import global from "../global.js"
export default {
    data(){
        return{
            
        }
    },
    methods: {
        async getSCMVendors(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/scm/get_scm_vendors_for_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getSCMVendorsFilter(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/filters/get_vendors', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getSCMProducts(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/scm/get_scm_products_for_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getTicketProducts(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/filters/get_products', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        }
    }
}